export default __webpack_public_path__ + "static/media/SpringsImg.304e94c1.jpg";